export const DATE_DISPLAY_FORMAT = "dd.MM.yyyy";
export const DATE_TIME_DISPLAY_FORMAT = "dd.MM.yyyy HH:mm:ss";
export const DATE_TIME_DISPLAY_WITHOUT_SECONDS_FORMAT = "dd.MM.yyyy HH:mm";
export const TIME_DISPLAY_FORMAT = "HH:mm:ss";
export const TIME_DISPLAY_WITHOUT_SECONDS_FORMAT = "HH:mm";

export const MONTH_YEAR_FORMAT = { month: "short", year: "numeric" } as const;

/**
 * Mantine v8 requires dates in ISO format (YYYY-MM-DD), e.g., "1988-12-19"
 *
 * Usage examples:
 * - With Luxon: luxonDateObject.toFormat("yyyy-MM-dd") or luxonDateObject.toISODate()
 * - With Day.js: dayjsDateObject.format("YYYY-MM-DD") or dayjsDateObject.toISOString().split("T")[0]
 */
export const LUXON_MANTINE_DATEFORMAT = "yyyy-MM-dd" as const;
export const DAYJS_MANTINE_DATEFORMAT = "YYYY-MM-DD" as const;
